export default __webpack_public_path__ + "static/media/6.36c21546.jpg";